<script setup lang="ts">
import type { NuxtError } from '#app'

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    error: NuxtError
  }>(),
  {}
)

const is404 = computed(() => props.error.statusCode === 404)

console.error(props.error)

const translatedError = computed(() => ({
  ...props.error,
  ...(is404.value && {
    statusMessage: t('notFound404.title'),
    message: t('notFound404.description')
  })
}))
</script>

<template>
  <UApp>
    <LayoutHeader />

    <UError :error="translatedError">
      <template v-if="is404" #links>
        <UButton
          size="lg"
          :label="t('notFound404.backToTradePage')"
          @click="clearError({ redirect: '/' })"
        />
      </template>
    </UError>
  </UApp>
</template>
